import styled from 'styled-components';
import Button from '../../../../BuildingBlocks/Button';
import { mixins, colors, media } from '../../../../css';
import { OPTION } from './FiltersContainer.constants';

const { pxToRem } = mixins;
const { colorBlue, colorGrey04, colorGrey05, colorWhite, colorGrey03Rgba, colorGrey02 } = colors;
const { FILTERS, DATES, ROOMS } = OPTION;
export const DEFAULT_BUTTON_BORDER_COLOR = colorGrey04;
export const DEFAULT_BUTTON_BORDER_COLOR_HOVER = colorGrey05;
export const DESKTOP_PANEL_BUTTON_DATES_WIDTH = 180;
export const DESKTOP_PANEL_BUTTON_ROOMS_WIDTH = 100;
export const DESKTOP_PANEL_BUTTON_FILTERS_WIDTH = 150;
export const DESKTOP_PANEL_BUTTON_PADDING = 27;
export const PANEL_BUTTON_BORDER_WIDTH = 1;

/* Shared */

export const PanelButton = styled(Button)`
  pointer-events: auto;
  border: ${PANEL_BUTTON_BORDER_WIDTH}px solid ${DEFAULT_BUTTON_BORDER_COLOR};
  padding: ${pxToRem(DESKTOP_PANEL_BUTTON_PADDING)};
  transition: border-color 125ms;
  &:nth-of-type(1) {
    border-left-color: ${DEFAULT_BUTTON_BORDER_COLOR};
    border-right-color: ${colorGrey04};
  }
  &:nth-of-type(2) {
    border-left-color: ${DEFAULT_BUTTON_BORDER_COLOR};
    border-right-color: ${DEFAULT_BUTTON_BORDER_COLOR};
  }
  &:nth-of-type(3) {
    border-left-color: ${colorGrey04};
    border-right-color: ${DEFAULT_BUTTON_BORDER_COLOR};
  }
  ${({ selected }) => selected && `border-color: ${colorBlue} !important;`};

  ${media.lessThan('md')`
    padding: ${pxToRem(7)};
  `};
`;

/* Mobile */

const MobileContainer = styled.div`
  position: absolute;
  top: ${({ mobile }) => (mobile ? pxToRem(12) : pxToRem(26))};
  left: ${({ mobile }) => (mobile ? pxToRem(32) : pxToRem(20))};
  right: ${({ mobile }) => (mobile ? pxToRem(32) : 'auto')};

  background: transparent;
  pointer-events: none;
  display: ${({ mobile }) => (mobile ? 'flex' : 'block')};
  justify-content: space-between;
`;

/* Desktop */

const DesktopContainer = styled.div`
  position: absolute;
  top: ${({ inset }) => pxToRem(inset)};
  left: ${({ inset }) => pxToRem(inset + 10)};
`;

const DesktopPanelButtonDates = styled(PanelButton)`
  width: ${pxToRem(DESKTOP_PANEL_BUTTON_DATES_WIDTH)};
`;
const DesktopPanelButtonRooms = styled(PanelButton)`
  width: ${pxToRem(DESKTOP_PANEL_BUTTON_ROOMS_WIDTH)};
`;
const DesktopPanelButtonFilters = styled(PanelButton)`
  width: ${pxToRem(DESKTOP_PANEL_BUTTON_FILTERS_WIDTH)};
  background-color: ${({ selected }) => (selected ? colorBlue : DEFAULT_BUTTON_BORDER_COLOR)};
  color: ${({ selected }) => (selected ? colorWhite : 'inherit')};
  &:hover {
    background-color: ${({ selected }) => (selected ? colorBlue : colorGrey05)};
  }
`;

const DesktopPanel = styled.div`
  background: ${colorWhite};
  position: absolute;
  right: 0;
  left: ${({ inset }) => pxToRem(inset)};
  width: ${pxToRem(
    DESKTOP_PANEL_BUTTON_DATES_WIDTH + DESKTOP_PANEL_BUTTON_ROOMS_WIDTH + DESKTOP_PANEL_BUTTON_FILTERS_WIDTH
  )};
  margin-top: ${({ inset }) => pxToRem(inset + 80 + 20)};
  max-height: ${({ inset }) => `calc(100% - ${pxToRem(inset + 80 + 20)})`};
  display: flex;
  flex-direction: column;
  &:before {
    content: ' ';
    position: absolute;
    height: ${pxToRem(15)};
    width: ${pxToRem(15)};
    background: ${colorWhite};
    transform: rotate(45deg);
    top: -${pxToRem(5)};
    right: ${({ selectedOption }) => {
      let offset;
      switch (selectedOption) {
        case FILTERS:
          offset = DESKTOP_PANEL_BUTTON_FILTERS_WIDTH / 2 + PANEL_BUTTON_BORDER_WIDTH * -2;
          break;
        case ROOMS:
          offset =
            DESKTOP_PANEL_BUTTON_ROOMS_WIDTH / 2 + DESKTOP_PANEL_BUTTON_FILTERS_WIDTH + PANEL_BUTTON_BORDER_WIDTH * -2;
          break;
        case DATES:
          offset =
            DESKTOP_PANEL_BUTTON_DATES_WIDTH / 2 +
            DESKTOP_PANEL_BUTTON_FILTERS_WIDTH +
            DESKTOP_PANEL_BUTTON_ROOMS_WIDTH +
            PANEL_BUTTON_BORDER_WIDTH * -2;
          break;
        default:
          offset = 0;
      }
      return pxToRem(offset);
    }};
  }
`;

const DesktopPanelRooms = styled(DesktopPanel)`
  background-color: ${colorGrey02};
  &:before {
    background: ${colorGrey02};
  }
`;

const DesktopPanelBodyRooms = styled.div`
  flex: 0 1 auto;
  padding: ${pxToRem(25)};
`;

const DesktopPanelBody = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  padding: ${pxToRem(3)} ${pxToRem(25)} 0;
`;

const DesktopPanelFooter = styled.div`
  height: ${pxToRem(75)};
  flex: 0 0 ${pxToRem(75)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px -1px 1px 0px ${colorGrey03Rgba(0.2)};
  padding: ${pxToRem(25)} ${pxToRem(25)} ${pxToRem(25)};
`;

export default {
  MobileContainer,
  PanelButton,
  DesktopContainer,
  DesktopPanel,
  DesktopPanelRooms,
  DesktopPanelButtonDates,
  DesktopPanelButtonRooms,
  DesktopPanelButtonFilters,
  DesktopPanelBody,
  DesktopPanelBodyRooms,
  DesktopPanelFooter
};
